module.exports = __webpack_public_path__ + "img/marsh-logo.23e191d7.png";